export interface IKBCatalogCategory {
    Id: string;
    DisplayName: string;
    Description: string;
    Expanded: boolean;
    KBCatalogs: IKBCatalog[];
}

export interface IKBCatalog {
    Id: string;
    IdParent: string;
    Description: string;
    DisplayName: string;
    Expanded: boolean;
    KBArtifacts: IKBArtifact[];
}

export interface IKBArtifact {
    Id: string;
    IdParent: string;
    Description: string;
    DisplayName: string;
    FileName: string;
    ArtifactStatus: string;
    ArtifactStatusLocalized: string;
}

export enum ArtifactStatus {
    Processing = "PROCESSING",
    Available = "AVAILABLE",
    Failed = "FAILED",
    ToProcess = "TOPROCESS",
    Unknown = "UNKNOWN"
}